import React from 'react'
import HeroSection from './pages/HeroSection';
import SecondSection from './pages/SecondSection';
import AppointmentSection from './pages/AppointmentSection';
import TemplatesSection from './pages/TemplatesSection';
import EventSection from './pages/EventSection';
import Subscribe from './pages/Subscribe';
import Footer from './pages/Footer';
import PromotionBanners from './pages/PromotionBanners';
import Benefits from './pages/Benefits';
import VideoSection from './pages/VideoSection';
import EventsSection from './pages/EventsSection';
import GallerySection from './pages/GallerySection';

const LandingNew = () => {
  return (
    <div>
       <HeroSection/>
       <PromotionBanners/>
       <Benefits/>
       <VideoSection/>
       <EventsSection/>
        <SecondSection/>
        <AppointmentSection/>
        {/* <TemplatesSection/> */}
        {/* <EventSection/> */}
        <GallerySection/>
        <Subscribe
        //  userData={userData}
         />
        {/* <Footer/> */}
        {/* <WhatsappIcon /> */}
    </div>
  )
}

export default LandingNew